import { createReducer } from 'typesafe-actions';

import { changeLocale } from '../actions';
import { Locale } from '../providers/LanguageProvider';

const initialState = {
  locale: Locale.EnglishUS,
};

const createIntlReducer = () =>
  createReducer(initialState).handleAction(changeLocale, (_, action) => ({
    locale: action.payload,
  }));

export default createIntlReducer;
